import React from 'react';
import { Play, Instagram, ArrowUpRight } from 'lucide-react';
import { journeyReels, instagramProfile } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const JourneyReels = () => {
  const { t } = useLang();
  const track = [...journeyReels, ...journeyReels, ...journeyReels];

  return (
    <section id="journey" className="py-24 md:py-32 bg-[#0B3D2E] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 text-center mb-14">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-6">
          <Instagram className="w-3.5 h-3.5" />
          @goldcare.clinic
        </div>
        <h2 className="font-serif-display text-4xl md:text-6xl mb-4">
          <span className="text-[#ffffff]">{t('jr.title')} </span>
          <span className="peach-text italic">{t('jr.title.italic', 'Unfiltered')}</span>
        </h2>
        <p className="text-[#ffffff]/70">
          {t('jr.sub')}
        </p>
      </div>

      <div className="relative">
        <div className="marquee-track">
          {track.map((reel, i) => (
            <div key={i} className="w-[220px] shrink-0 mx-3">
              <a
                href={instagramProfile}
                target="_blank"
                rel="noopener noreferrer"
                className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden group block card-hover"
              >
                <img
                  src={reel.thumb}
                  alt={reel.label}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/40 backdrop-blur flex items-center justify-center text-white">
                  <Instagram className="w-4 h-4" />
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-md border border-white/40 flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:border-[#D4AF37] transition-all">
                    <Play className="w-5 h-5 text-white group-hover:text-[#0B3D2E] fill-current ml-0.5" />
                  </div>
                </div>
                <div className="absolute bottom-3 left-3 right-3 text-white">
                  <div className="text-sm font-medium leading-tight mb-1 line-clamp-2">{reel.label}</div>
                  <div className="flex items-center gap-1.5 text-[11px] text-white/85">
                    <Instagram className="w-3 h-3" />
                    <span>{reel.views}</span>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>

        <div className="absolute top-0 left-0 bottom-0 w-24 bg-gradient-to-r from-[#0B3D2E] to-transparent pointer-events-none" />
        <div className="absolute top-0 right-0 bottom-0 w-24 bg-gradient-to-l from-[#0B3D2E] to-transparent pointer-events-none" />
      </div>

      <div className="text-center mt-12">
        <a
          href={instagramProfile}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-ghost-gold inline-flex items-center gap-2 px-7 py-3 rounded-full"
        >
          <Instagram className="w-4 h-4" />
          Follow @goldcare.clinic
          <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};

export default JourneyReels;
